import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { resetStore } from "redux/CreateDataset/actions";
import { setShowDSCreationWarning } from "redux/Modals/actions";
import { isOnPremUser } from "helpers/utility/utilities";
import useCreateDataset from "hooks/useCreateDataset";

export function useHandleDatasetCreation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createNewDataset } = useCreateDataset();

  const handleDatasetCreation = async () => {
    const datasetCreationEnabled = (
      process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || ""
    )
      .trim()
      .replace(/"/g, "");

    // Only show on-prem warning if dataset creation from UI is NOT explicitly enabled
    if (isOnPremUser() && datasetCreationEnabled !== "true") {
      dispatch(setShowDSCreationWarning(true));
      return;
    }

    if (datasetCreationEnabled !== "true") {
      return;
    }
    //open the new dataset creation flow
    dispatch(resetStore());
    const newDatasetId = await createNewDataset();

    if (newDatasetId) {
      navigate(`/dataset/${newDatasetId}/create`);
    }
    return;
  };

  return { handleDatasetCreation };
}
